import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'Receptionist' }]

const CareersPage = () => (
	<main className="mx-auto my-10 max-w-7xl">
		<Link to="/" prefetch="intent" className="text-blue-600 underline">
			Home
		</Link>{' '}
		&rarr;{' '}
		<Link to="/careers/" prefetch="intent" className="text-blue-600 underline">
			Careers
		</Link>
		<br />
		<br />
		<h1 className="py-3 text-4xl font-black">Receptionist</h1>
		<p
			data-paragraph
			className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
		>
			<h3>Job Description</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The receptionist is the first voice people experience when they connect
				with us. We are seeking a bright, compassionate individual to welcome
				clients into our office direct them to the person who can meet their
				needs.
			</p>
			<h3>Job Responsibilities</h3>
			<ul>
				<li>Greet office visitors with enthusiasm</li>
				<li>
					Answer multi-line phone system and route calls to the proper person
				</li>
				<li>Perform simple filing and record-keeping tasks</li>
				<li>Reach out to clients to make reminder calls</li>
			</ul>
			<h3>Job Requirements</h3>
			<ul>
				<li>Exhibit professional phone and interpersonal etiquette</li>
				<li>Display highly capable problem-solving skills</li>
				<li>Possess a strong work ethic</li>
				<li>Work with a positive attitude</li>
				<li>
					Demonstrate strong communication and empathetic listening skills
				</li>
			</ul>
			<br />
			Send an email with your resume and cover letter to{' '}
			<a href="mailto:careers@steeleagency.com">careers@steeleagency.com</a> to
			start the application process.
		</p>
	</main>
)

export default CareersPage
